import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import CookieConsent from 'react-cookie-consent'
import { Helmet } from 'react-helmet'
import useCookieConsent from '../hooks/useCookieConsent'

const localizedPaths = new Set([
  '/', '/clinic-website', '/clinic-seo', '/clinic-chatbot', '/clinic-maintenance', '/works',
  '/works/murakami-clinic', '/works/sunrise-sachi-clinic', '/works/henkotsu', '/about',
  '/assessment', '/contact', '/technology', '/clinic-website-preview',
  '/clinic-opening-website', '/clinic-website-renewal',
])

const Layout = ({ children, location }) => {
  const [is404, setIs404] = useState(false)
  const path = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '')
  const { showConsentBanner, handleAccept, handleDecline } = useCookieConsent(path)
  const lang = path === '/zh' || path.startsWith('/zh/') ? 'ZH' : path === '/en' || path.startsWith('/en/') ? 'EN' : 'JA'

  const canonical = `https://1f8.co.jp${path}`
  const rawBasePath = path.replace(/^\/(en|zh)(?=\/|$)/, '') || '/'
  const basePath = rawBasePath === '/company' ? '/about' : rawBasePath
  const jaPath = basePath === '/about' ? '/company' : basePath
  const jaUrl = `https://1f8.co.jp${jaPath === '/' ? '/' : jaPath}`
  const enUrl = `https://1f8.co.jp/en${basePath === '/' ? '' : basePath}`
  const zhUrl = `https://1f8.co.jp/zh${basePath === '/' ? '' : basePath}`

  const allSitePage = useStaticQuery(graphql`
    query AllPagesQuery {
      allSitePage {
        nodes {
          path
        }
      }
    }
  `)
  const hasEquivalent = localizedPaths.has(basePath)

  useEffect(() => {
    const allPaths = allSitePage.allSitePage.nodes.map(node => node.path)
    if (allPaths && location.pathname) {
      const is404 = location.pathname === '/404/' || !(allPaths?.find((path) => path === location.pathname))
      setIs404(is404)
    }
  }, [allSitePage, location.pathname])

  const cookieConsentText = {
    JA: 'アクセス解析のためCookieを使用します。詳細は',
    EN: 'We use cookies for website analytics. See our ',
    ZH: '我们使用 Cookie 进行网站分析。详情请参阅',
  }

  const privacyPolicyText = {
    JA: 'プライバシーポリシー',
    EN: 'Privacy Policy',
    ZH: '隐私政策',
  }

  const buttonText = {
    JA: 'OK',
    EN: 'Accept',
    ZH: '接受',
  }

  return (
    <>
      <Helmet>
        <link rel='canonical' href={canonical} />
        {hasEquivalent && <link rel='alternate' hrefLang='ja' href={jaUrl} />}
        {hasEquivalent && <link rel='alternate' hrefLang='en' href={enUrl} />}
        {hasEquivalent && <link rel='alternate' hrefLang='zh-Hans' href={zhUrl} />}
        {hasEquivalent && <link rel='alternate' hrefLang='x-default' href={jaUrl} />}
      </Helmet>
      <div className='overflow-hidden'>
        {children}
      </div>
      {!is404 && showConsentBanner && (
        <CookieConsent
          location='bottom'
          cookieName='gatsby-gdpr-google-tagmanager'
          style={{ background: 'white', color: 'black', borderTop: '0.5px solid gray', alignItems: 'center', padding: '12px 16px' }}
          contentStyle={{ flex: '1 1 260px', margin: '6px 12px', fontSize: '14px' }}
          buttonText={buttonText[lang]}
          declineButtonText={lang === 'JA' ? '拒否' : lang === 'ZH' ? '拒绝' : 'Decline'}
          enableDeclineButton
          buttonStyle={{
            color: 'white',
            background: '#08BCA8',
            border: '1px solid #08BCA8',
            borderRadius: '5px',
            padding: '8px 22px',
            transition: 'background-color 0.3s, color 0.3s',
          }}
          declineButtonStyle={{ color: '#555', background: 'transparent', padding: '8px 12px', textDecoration: 'underline' }}
          buttonClasses='cookie-consent-button'
          onAccept={handleAccept}
          onDecline={handleDecline}
        >
          {cookieConsentText[lang]}
          <a href='/privacy' style={{ color: 'black', textDecoration: 'underline' }}>
            {privacyPolicyText[lang]}
          </a>
          {lang === 'JA' ? 'をご覧ください。' : lang === 'ZH' ? '。' : '.'}
        </CookieConsent>
      )}
    </>
  )
}

export default Layout